import { Component, OnInit } from '@angular/core';
import { CrudService } from '../../../crud/crud.service';
import { environment } from "../../../../environments/environment";

import { NotificationsService } from 'angular2-notifications';

import { Mensaje } from "../../../mensaje";
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable';
import * as jQuery from 'jquery';
import * as moment from 'moment';


declare var XLSX: any;


@Component({
  selector: "app-grupo-lista",
  templateUrl: "./lista.component.html"
})
export class ListaComponent implements OnInit {
  permisos = JSON.parse(localStorage.getItem("permisos"));

  tamano = document.body.clientHeight;
  detalles: any = "";
  API_PATH = environment.API_PATH;

  carreras_planes_id;
  periodos_escolares_id;
  nivel;
  filtro;
  fNombreGrupo;
  grupos_id;
  nombreGrupo;

  dato = [];
  item;
  documentos = [];
  cargando = false;
  borrarCargando: boolean = false;
  baja: boolean = true;

  mensajeResponse: Mensaje = new Mensaje(true);

  logo_sucursal = "";
  logo_empresa = "";
  logo_carrera = "";

  public options = {
    position: ["middle", "center"],
    timeOut: 3000,
    lastOnBottom: true
  };

  configuracion = JSON.parse(localStorage.getItem("configuracion"));

  constructor(private crudService: CrudService,
    private notificacion: NotificationsService,
    private http: HttpClient) { }

    

  ngOnInit() {
    document.getElementById("catalogos").click();
  }

  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
      this.logo_carrera = logos.carrera;
    }
  }

  peticionReinicio(id: any): Observable<any> {
    let url = `${this.API_PATH}/api/v1/reset-conteo-grupo/${id}`
    return this.http.get(url);
  }

  nuevo_grupo(e, id, tipo) {
    this.detalles = [];
    this.item = id;
    this.cargando = true;
    this.crudService.ver(id, "grupo").subscribe(
      resultado => {
        this.detalles = resultado.data;
        this.cargando = false;
      },
      error => {
        this.cargando = false;
      }
    );
    if (tipo == "lista")
      document.getElementById("detalle-grupo").classList.add("is-active");
    else
      document.getElementById("agregar-beca").classList.add("is-active");
  }

  quitar_beca(e, id) {
    this.item = id;
    document.getElementById("quitar-beca").classList.add("is-active");
  }
  becas_id = '';
  agregar_beca(e, id) {
    this.item = id;
    document.getElementById("agregar-beca").classList.add("is-active");
  }


  reiniciar(e,id){
    //console.log(id);
    this.item = id;
    document.getElementById("reiniciar-conteo").classList.add("is-active")
  }

  reincia_conteo(item){
    //console.log(item);
    this.cargando = true;

    let id = item;
    this.peticionReinicio(id).subscribe((resultado) =>{
      //console.log(resultado);
      this.cargando = false;
      this.borrarCargando = false;
      this.mensajeResponse.mostrar = true;
      this.mensajeResponse.texto = "Se reinicio el conteo del grupo correctamente";
      this.mensajeResponse.clase = "success";
      this.mensaje(2);
      this.cancelarFiltros("reiniciar-conteo");
    }, e =>{
      console.log(e);
      this.mensajeResponse.mostrar = true;
      this.mensajeResponse.texto = "Ocurrio un error";
      this.mensajeResponse.clase = "danger";
      this.mensaje(2);
    })
  }

  cerrar_reinicio() {
    document.getElementById("reiniciar-conteo").classList.remove("is-active");
  }

  /**
   * Este método se encarga de la eliminacion de las becas de los alumnos de un grupo
   * en la api
   * @param item contiene el valod del elemento para afectar
   * @return void
   */
  borrar_beca(item): void {
    this.cargando = true;
    this.borrarCargando = true;
    this.crudService.editar(this.item, [], "grupo/quitar-beca").subscribe(
      data => {
        this.cargando = false;
        this.borrarCargando = false;

        // this.dato.splice(index, 1);

        this.mensajeResponse.mostrar = true;
        this.mensajeResponse.texto = "Se eliminó la beca para el grupo.";
        this.mensajeResponse.clase = "success";
        this.mensaje(2);

        this.cancelarFiltros("quitar-beca")
      },
      error => {
        this.cargando = false;
        this.borrarCargando = false;

        this.mensajeResponse.mostrar = true;

        this.cancelarFiltros("quitar-beca");

        try {
          let e = error.json();
          if (error.status == 401) {
            this.mensajeResponse.texto =
              "No tiene permiso para hacer esta operación.";
            this.mensajeResponse.clase = "danger";
            this.mensaje(2);
          }
        } catch (e) {
          if (error.status == 500) {
            this.mensajeResponse.texto = "500 (Error interno del servidor)";
          } else {
            this.mensajeResponse.texto =
              "No se puede interpretar el error. Por favor contacte con soporte técnico si esto vuelve a ocurrir.";
          }
          this.mensajeResponse.clase = "danger";
          this.mensaje(2);
        }
      }
    );
  }

  asignar_beca(): void {
    this.cargando = true;
    this.borrarCargando = true;

    this.crudService.editar(this.detalles.id, this.detalles, "grupo/agregar-beca").subscribe(
      data => {
        this.cargando = false;
        this.borrarCargando = false;

        // this.dato.splice(index, 1);

        this.mensajeResponse.mostrar = true;
        this.mensajeResponse.texto = "Se agrego la beca para el grupo.";
        this.mensajeResponse.clase = "success";
        this.mensaje(2);

        this.cancelarFiltros("quitar-beca")
      },
      error => {
        this.cargando = false;
        this.borrarCargando = false;

        this.mensajeResponse.mostrar = true;

        this.cancelarFiltros("quitar-beca");

        try {
          let e = error.json();
          if (error.status == 401) {
            this.mensajeResponse.texto =
              "No tiene permiso para hacer esta operación.";
            this.mensajeResponse.clase = "danger";
            this.mensaje(2);
          }
        } catch (e) {
          if (error.status == 500) {
            this.mensajeResponse.texto = "500 (Error interno del servidor)";
          } else {
            this.mensajeResponse.texto =
              "No se puede interpretar el error. Por favor contacte con soporte técnico si esto vuelve a ocurrir.";
          }
          this.mensajeResponse.clase = "danger";
          this.mensaje(2);
        }
      }
    );
  }

  cerrar_modal() {
    document.getElementById("detalle-grupo").classList.remove("is-active");
  }

  cancelarFiltros(id) {
    document.getElementById(id).classList.remove("is-active");
    this.item = '';
  }

  mensaje(cuentaAtras: number = 6, posicion: any[] = ["middle", "center"]): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };

    if (this.mensajeResponse.clase == "alert")
      this.notificacion.alert(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "success")
      this.notificacion.success(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "info")
      this.notificacion.info(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "warning" ||
      this.mensajeResponse.clase == "warn"
    )
      this.notificacion.warn(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "error" ||
      this.mensajeResponse.clase == "danger"
    )
      this.notificacion.error(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );
  }

  imprimirLista(asistencia) {
    let doc = new jsPDF("p", "mm", "letter");

    doc.setLineWidth(0.1);
    doc.setDrawColor(1, 1, 1);
    doc.setFillColor(255, 255, 255);
    doc.setFont("helvetica");

    let conteo_lienas = 10;

    doc.setFontSize(12);
    doc.setFont("helvetica", "", "bold");

    let logo = this.logo_sucursal != '' ? this.logo_sucursal : this.logo_empresa;
    if (logo != '' && logo != undefined && logo != null)
      doc.addImage(logo, "PNG", 7, 5, 20, 20, "left", "FAST");

    if (this.logo_carrera != '')
      doc.addImage(this.logo_carrera, "PNG", 180, 5, 20, 20, "right", "FAST");
    //Nombre empresa
    doc.setFontSize(15);
    doc.setFont("helvetica", "", "bold");
    doc.setFont("helvetica");
    doc.text(this.configuracion.empresa.nombre, 108, 12, { align: "center" });

    doc.setFontSize(14);
    doc.setFont("helvetica", "", "bold");
    doc.text(this.configuracion.empresa.subnombre, 108, 18, { align: "center" });

    doc.setFontSize(10);
    doc.setFont("helvetica", "", "normal");
    doc.text('Campus: ' + this.configuracion.sucursal.nombre, 110, 24, { align: 'center' });

    doc.setFontSize(10);
    doc.setFont("helvetica", "", "bold");
    doc.text('LISTA DE ASISTENCIA', 110, 30, { align: 'center' });

    conteo_lienas += 38;
    doc.setFontSize(8);

    doc.text("GRUPO: ", 10, conteo_lienas, { align: "left" });
    doc.text(this.detalles.periodos_escolares.tipos_periodos.nombre_para_mostrar + ": ", 60, conteo_lienas, { align: "left" });
    doc.text("TURNO: ", 95, conteo_lienas, { align: "left" });
    doc.text("PERIODO: ", 130, conteo_lienas, { align: "left" });

    doc.line(25, conteo_lienas + 1, 55, conteo_lienas + 1);
    doc.line(84, conteo_lienas + 1, 92, conteo_lienas + 1);
    doc.line(107, conteo_lienas + 1, 126, conteo_lienas + 1);
    doc.line(145, conteo_lienas + 1, 205, conteo_lienas + 1);

    doc.text("CARRERA: ", 10, conteo_lienas + 5, { align: 'left' });
    doc.line(25, conteo_lienas + 6, 145, conteo_lienas + 6);

    doc.text("CLAVE: ", 150, conteo_lienas + 5, { align: "left" });
    doc.line(162, conteo_lienas + 6, 205, conteo_lienas + 6);

    doc.setFont("helvetica", "", "normal");

    doc.text(this.detalles.clave + " - " + this.detalles.nivel + this.detalles.identificador, 28, conteo_lienas, { align: "left" });
    doc.text(this.detalles.nivel + "", 87, conteo_lienas, { align: "left" });
    doc.text(this.detalles.turnos.nombre, 108, conteo_lienas, { align: "left" });
    doc.text(this.detalles.periodos_escolares.nombre, 148, conteo_lienas, { align: "left" });

    doc.text(this.detalles.carreras_planes.carreras.nombre + " - " + this.detalles.carreras_planes.planes_estudios.nombre, 28, conteo_lienas + 5, { align: "left" });
    doc.text(this.detalles.carreras_planes.carreras.sigla, 175, conteo_lienas + 5, { align: "left" });

    conteo_lienas += 12;

    ///////////////////////////

    doc.setFontSize(8);
    doc.setFont("helvetica", "", "bold");

    let columns = [
      { title: "N", dataKey: "id" },
      { title: "NOMBRE DEL ALUMNO", dataKey: "alumno" }
    ];
    let conteo = 0; let tamano = 0;
    if (asistencia == 2) {
      columns.push({ title: "MATRICULA", dataKey: "matricula" })
      columns.push({ title: "CURP", dataKey: "curp" });
      columns.push({ title: "CORREO", dataKey: "correo" });
      columns.push({ title: "CONTACTO", dataKey: "contacto" });
    } else {
      if (asistencia) {
        let dias = 20;
        if (this.detalles.periodos_escolares.modalidades.modalidades_dias.length < 3)
          dias = 4;

        if (this.detalles.periodos_escolares.modalidades.modalidades_dias.length == 3)
          dias = 12;

        tamano = dias / this.detalles.periodos_escolares.modalidades.modalidades_dias.length;
        conteo = 1;
        for (let i = 0; i < tamano; i++) {
          this.detalles.periodos_escolares.modalidades.modalidades_dias.forEach(par => {
            columns.push({
              title: par.dias_semanas.nombre.substr(0, 1).toUpperCase(),
              dataKey: "dia" + conteo
            });
            conteo++;
          });
        }
      } else {
        columns.push({ title: "DESCRIPCIÓN", dataKey: "descripcion" });
      }
    }

    let rows = []; let linea = 1;
    this.detalles.grupos_alumnos.forEach(par => {
      if (this.baja != true) {
        if (par.estatus_alumno.etiqueta != "BAN") {
          rows.push({
            id: linea,
            alumno: par.alumnos.apellido_paterno + " " + par.alumnos.apellido_materno + " " + par.alumnos.nombre
          });

          if (asistencia == 2) {
            let contacto = "";
            par.contactos.forEach(cont => {
              contacto += cont.valor;
            });
            rows[rows.length - 1]["matricula"] = par.alumnos.matricula;
            rows[rows.length - 1]["curp"] = par.alumnos.curp;
            rows[rows.length - 1]["correo"] = par.alumnos.email;
            rows[rows.length - 1]["contacto"] = contacto;
          } else {
            if (asistencia) {
              conteo = 1;
              for (let i = 0; i < tamano; i++) {
                this.detalles.periodos_escolares.modalidades.modalidades_dias.forEach(par => {
                  rows[linea - 1]["dia" + conteo] = '';
                  conteo++;
                });
              }
            } else {
              rows[rows.length - 1]["descripcion"] = '';
            }
          }

          linea++;
        }
      } else {

        rows.push({
          id: linea,
          alumno: par.alumnos.apellido_paterno + " " + par.alumnos.apellido_materno + " " + par.alumnos.nombre
        });

        if (asistencia == 2) {
          let contacto = "";
          par.contactos.forEach(cont => {
            contacto += cont.valor;
          });
          rows[rows.length - 1]["matricula"] = par.alumnos.matricula;
          rows[rows.length - 1]["curp"] = par.alumnos.curp;
          rows[rows.length - 1]["correo"] = par.alumnos.email;
          rows[rows.length - 1]["contacto"] = contacto;
        } else {
          if (asistencia) {
            conteo = 1;
            for (let i = 0; i < tamano; i++) {
              this.detalles.periodos_escolares.modalidades.modalidades_dias.forEach(par => {
                rows[linea - 1]["dia" + conteo] = '';
                conteo++;
              });
            }
          } else {
            rows[rows.length - 1]["descripcion"] = '';
          }
        }

        linea++;
      }
    });

    let fs = 8;
    if (asistencia == 2) {
      fs = 7;
    }

    (doc as any).autoTable({
      columns: columns,
      body: rows,
      didParseCell: function (cell) {
        let data = cell;
        cell = cell.cell;
        cell.styles.fillColor = "#ffffff";
      },
      startY: conteo_lienas,
      styles: {
        fontSize: fs,
        font: "helvetica",
        halign: "center",
        fillColor: "#FFFFFF",
        textColor: "#000000",
        lineColor: "#000000",
        lineWidth: 0.1,
        cellPadding: 0.8
      },
      headStyles: {
        lineColor: "#000000",
        lineWidth: 0.1
      },
      theme: "grid",
      margin: { right: 10, left: 10 },
      columnStyles: {
        id: { cellWidth: 5 },
        alumno: {
          cellWidth: 60, halign: "left"
        }
      }
    });

    // doc.autoPrint();
    //const string = (doc as any).output('datauristring', 'lista.pdf');
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe = "<iframe border='0' style='border:0px' width='100%' height='100%' src='" + string + "'></iframe>"

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/
  }


  


    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  
  
  exportarListaExcel(data: any[], grupo_data: any | null, clave : null,nivel: null, identificador: null, sigla: null, periodo_escolar) {
  
    console.log('INICIA EXPORTADO DE LISTA A EXCEL');
     console.log(periodo_escolar);
    console.log(data);
  
    const worksheetData: any[] = [];
    let totalImporte = 0;
  
    data.forEach(item => {
      // Acceder y validar datos

      let statex = 'Reinscripción';

      if(nivel == 1)
      {
        statex = "Inscripción";
      }

      let ciclo = "0000";
      if (typeof periodo_escolar === 'string' ) {
          ciclo = periodo_escolar.substring(0, 4);
        }
      let genero = 'H';

      if(item.sexo == 'F') 
      {
        genero = 'M';
      }

      let pais_nacimiento   = this.obtenerNombreDesdeArray('paises_nacimiento',item.pais_nacimiento);
      let estado_nacimiento = this.obtenerNombreDesdeArray('estados_nacimiento',item.estado_nacimiento);
      let pais_procedencia  = this.obtenerNombreDesdeArray('paises_nacimiento',item.pais_procedencia);
      let idioma               = this.obtenerNombreDesdeArray('idiomas',item.idioma);
      let necesidad_educativa  = this.obtenerNombreDesdeArray('necesidades_educativas',item.necesidad_educativa_especial);

      let turno            = grupo_data.turnos.nombre;
      let rvoe             = grupo_data.carreras_planes?.carreras?.rvoe;
      let fecha_acuerdo    = grupo_data.carreras_planes?.carreras?.fecha_acuerdo;
      let nivel_educativo  = grupo_data.carreras_planes?.carreras?.niveles_educativos?.nombre;

      let modalidad_educativa  = grupo_data.periodos_escolares?.modalidades?.nombre_imprimir;


      if(item.estatus_alumno.etiqueta != 'BAN')
      {

          worksheetData.push({

          'Estatus': statex,
          'Año del ciclo escolar': ciclo,
          'Nombre del alumno': item.nombre,
          'Primer Apellido': item.apellido_paterno,
          'Segundo Apellido': item.apellido_materno,
          'Género': genero,
          'CURP': item.curp,
          'Fecha de Nacimiento': item.fecha_nacimiento,
          'País de Nacimiento': pais_nacimiento,
          'Entidad Federativa o Ciudad de Nacimiento': estado_nacimiento,
          'País de Procedencia': pais_procedencia,
          'Idioma/Lengua': idioma,
          'Necesidad Educativa Especial': necesidad_educativa,
          'Presenta Antecedente Académico': 'Si',
          'CCT': this.configuracion.sucursal.clave,
          'Matrícula Institucional': item.matricula,
          'Nivel Educativo': nivel_educativo,
          'Clave de la Institución': '',
          'Clave de Carrera': '',
          'Turno': turno,
          'Número de Acuerdo de RVOE': rvoe,
          'Fecha de Acuerdo de RVOE': fecha_acuerdo,
          'Modalidad Educativa': modalidad_educativa

      });

      }
  
  
      
    });
  
    // Agregar la fila de total al final
    /*
    worksheetData.push({
      'FECHA DE PAGO': '',
      CODIGO: '',
      NRF: '',
      'FORMA DE PAGO': 'TOTAL IMPORTE:',
       IMPORTE: totalImporte,
       CONCEPTO: '',
       ALUMNO: '',
       CARRERA: '',
       GRADO: '',
       GRUPO: '',
      'FECHA DE CAPTURA': '',
      CAJERO: ''
    });*/
  
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  
    // Ajustar ancho de columnas automáticamente
    const columnWidths = Object.keys(worksheetData[0]).map(key => {
      const maxLength = worksheetData.reduce((max, row) => {
        const val = row[key] ? row[key].toString() : '';
        return Math.max(max, val.length);
      }, key.length);
      return { wch: maxLength + 2 }; // padding
    });
  
    worksheet['!cols'] = columnWidths;
  
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Lista de Grupo');
    XLSX.writeFile(workbook, 'PRELIMINAR_ANEXO_8_'+periodo_escolar.substring(0, 4)+'_'+sigla+'_'+clave+'-'+nivel+'-'+identificador+'.xlsx');
  }
  
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


    // Función que busca el nombre por id
  obtenerNombrePais(idBuscado: number): string | null {
    const pais = this.paises_nacimiento.find(item => item.id === idBuscado);
    return pais ? pais.nombre : null; // o puedes retornar 'Desconocido'
  }

  obtenerNombreDesdeArray(nombreArray: keyof ListaComponent, idBuscado: number): string {
    const array = this[nombreArray] as ItemGenerico[];
    if (Array.isArray(array)) {
      const item = array.find(e => e.id === idBuscado);
      return item ? item.nombre : 'No Disponible';
    }
    return 'ERROR DE DATOS';
  }

  idiomas: ItemGenerico[] = [
{'id':1,'nombre':'Español'},
{'id':2,'nombre':'Otro'}
  ];

  necesidades_educativas: ItemGenerico[] = [
{'id':1,'nombre':'No aplica'},
{'id':2,'nombre':'Con discapacidad'},
{'id':3,'nombre':'Con aptitudes sobresalientes'}
  ];

		paises_nacimiento: ItemGenerico[] = [
  { id: 1, nombre: 'Afganistán' },
  { id: 2, nombre: 'Albania' },
  { id: 3, nombre: 'Alemania' },
  { id: 4, nombre: 'Andorra' },
  { id: 5, nombre: 'Angola' },
  { id: 6, nombre: 'Antigua y Barbuda' },
  { id: 7, nombre: 'Arabia Saudita' },
  { id: 8, nombre: 'Argelia' },
  { id: 9, nombre: 'Argentina' },
  { id: 10, nombre: 'Armenia' },
  { id: 11, nombre: 'Australia' },
  { id: 12, nombre: 'Austria' },
  { id: 13, nombre: 'Azerbaiyán' },
  { id: 14, nombre: 'Bahamas' },
  { id: 15, nombre: 'Bangladés' },
  { id: 16, nombre: 'Barbados' },
  { id: 17, nombre: 'Baréin' },
  { id: 18, nombre: 'Bélgica' },
  { id: 19, nombre: 'Belice' },
  { id: 20, nombre: 'Benín' },
  { id: 21, nombre: 'Bielorrusia' },
  { id: 22, nombre: 'Bolivia' },
  { id: 23, nombre: 'Bosnia y Herzegovina' },
  { id: 24, nombre: 'Botsuana' },
  { id: 25, nombre: 'Brasil' },
  { id: 26, nombre: 'Brunéi' },
  { id: 27, nombre: 'Bulgaria' },
  { id: 28, nombre: 'Burkina Faso' },
  { id: 29, nombre: 'Burundi' },
  { id: 30, nombre: 'Bután' },
  { id: 31, nombre: 'Cabo Verde' },
  { id: 32, nombre: 'Camboya' },
  { id: 33, nombre: 'Camerún' },
  { id: 34, nombre: 'Canadá' },
  { id: 35, nombre: 'Catar' },
  { id: 36, nombre: 'Chad' },
  { id: 37, nombre: 'Chile' },
  { id: 38, nombre: 'China' },
  { id: 39, nombre: 'Chipre' },
  { id: 40, nombre: 'Colombia' },
  { id: 41, nombre: 'Comoras' },
  { id: 42, nombre: 'Corea del Norte' },
  { id: 43, nombre: 'Corea del Sur' },
  { id: 44, nombre: 'Costa de Marfil' },
  { id: 45, nombre: 'Costa Rica' },
  { id: 46, nombre: 'Croacia' },
  { id: 47, nombre: 'Cuba' },
  { id: 48, nombre: 'Dinamarca' },
  { id: 49, nombre: 'Dominica' },
  { id: 50, nombre: 'Ecuador' },
  { id: 51, nombre: 'Egipto' },
  { id: 52, nombre: 'El Salvador' },
  { id: 53, nombre: 'Emiratos Árabes Unidos' },
  { id: 54, nombre: 'Eritrea' },
  { id: 55, nombre: 'Eslovaquia' },
  { id: 56, nombre: 'Eslovenia' },
  { id: 57, nombre: 'España' },
  { id: 58, nombre: 'Estados Unidos' },
  { id: 59, nombre: 'Estonia' },
  { id: 60, nombre: 'Etiopía' },
  { id: 61, nombre: 'Filipinas' },
  { id: 62, nombre: 'Finlandia' },
  { id: 63, nombre: 'Fiyi' },
  { id: 64, nombre: 'Francia' },
  { id: 65, nombre: 'Gabón' },
  { id: 66, nombre: 'Gambia' },
  { id: 67, nombre: 'Georgia' },
  { id: 68, nombre: 'Ghana' },
  { id: 69, nombre: 'Granada' },
  { id: 70, nombre: 'Grecia' },
  { id: 71, nombre: 'Guatemala' },
  { id: 72, nombre: 'Guinea' },
  { id: 73, nombre: 'Guinea Ecuatorial' },
  { id: 74, nombre: 'Guinea-Bissau' },
  { id: 75, nombre: 'Guyana' },
  { id: 76, nombre: 'Haití' },
  { id: 77, nombre: 'Honduras' },
  { id: 78, nombre: 'Hungría' },
  { id: 79, nombre: 'India' },
  { id: 80, nombre: 'Indonesia' },
  { id: 81, nombre: 'Irak' },
  { id: 82, nombre: 'Irán' },
  { id: 83, nombre: 'Irlanda' },
  { id: 84, nombre: 'Islandia' },
  { id: 85, nombre: 'Israel' },
  { id: 86, nombre: 'Italia' },
  { id: 87, nombre: 'Jamaica' },
  { id: 88, nombre: 'Japón' },
  { id: 89, nombre: 'Jordania' },
  { id: 90, nombre: 'Kazajistán' },
  { id: 91, nombre: 'Kenia' },
  { id: 92, nombre: 'Kirguistán' },
  { id: 93, nombre: 'Kiribati' },
  { id: 94, nombre: 'Kuwait' },
  { id: 95, nombre: 'Laos' },
  { id: 96, nombre: 'Lesoto' },
  { id: 97, nombre: 'Letonia' },
  { id: 98, nombre: 'Líbano' },
  { id: 99, nombre: 'Liberia' },
  { id: 100, nombre: 'Libia' },
  { id: 101, nombre: 'Liechtenstein' },
  { id: 102, nombre: 'Lituania' },
  { id: 103, nombre: 'Luxemburgo' },
  { id: 104, nombre: 'Madagascar' },
  { id: 105, nombre: 'Malaui' },
  { id: 106, nombre: 'Malasia' },
  { id: 107, nombre: 'Maldivas' },
  { id: 108, nombre: 'Malí' },
  { id: 109, nombre: 'Malta' },
  { id: 110, nombre: 'Marruecos' },
  { id: 111, nombre: 'Marshall, Islas' },
  { id: 112, nombre: 'Mauricio' },
  { id: 113, nombre: 'Mauritania' },
  { id: 114, nombre: 'México' },
  { id: 115, nombre: 'Micronesia' },
  { id: 116, nombre: 'Moldavia' },
  { id: 117, nombre: 'Mónaco' },
  { id: 118, nombre: 'Mongolia' },
  { id: 119, nombre: 'Montenegro' },
  { id: 120, nombre: 'Mozambique' },
  { id: 121, nombre: 'Namibia' },
  { id: 122, nombre: 'Nauru' },
  { id: 123, nombre: 'Nepal' },
  { id: 124, nombre: 'Nicaragua' },
  { id: 125, nombre: 'Níger' },
  { id: 126, nombre: 'Nigeria' },
  { id: 127, nombre: 'Noruega' },
  { id: 128, nombre: 'Nueva Zelanda' },
  { id: 129, nombre: 'Omán' },
  { id: 130, nombre: 'Países Bajos' },
  { id: 131, nombre: 'Pakistán' },
  { id: 132, nombre: 'Palaos' },
  { id: 133, nombre: 'Panamá' },
  { id: 134, nombre: 'Papúa Nueva Guinea' },
  { id: 135, nombre: 'Paraguay' },
  { id: 136, nombre: 'Perú' },
  { id: 137, nombre: 'Polonia' },
  { id: 138, nombre: 'Portugal' },
  { id: 139, nombre: 'Reino Unido' },
  { id: 140, nombre: 'República Centroafricana' },
  { id: 141, nombre: 'República Checa' },
  { id: 142, nombre: 'República del Congo' },
  { id: 143, nombre: 'República Democrática del Congo' },
  { id: 144, nombre: 'República Dominicana' },
  { id: 145, nombre: 'Ruanda' },
  { id: 146, nombre: 'Rumania' },
  { id: 147, nombre: 'Rusia' },
  { id: 148, nombre: 'Samoa' },
  { id: 149, nombre: 'San Cristóbal y Nieves' },
  { id: 150, nombre: 'San Marino' },
  { id: 151, nombre: 'San Vicente y las Granadinas' },
  { id: 152, nombre: 'Santa Lucía' },
  { id: 153, nombre: 'Santo Tomé y Príncipe' },
  { id: 154, nombre: 'Senegal' },
  { id: 155, nombre: 'Serbia' },
  { id: 156, nombre: 'Seychelles' },
  { id: 157, nombre: 'Sierra Leona' },
  { id: 158, nombre: 'Singapur' },
  { id: 159, nombre: 'Siria' },
  { id: 160, nombre: 'Somalia' },
  { id: 161, nombre: 'Sri Lanka' },
  { id: 162, nombre: 'Sudáfrica' },
  { id: 163, nombre: 'Sudán' },
  { id: 164, nombre: 'Sudán del Sur' },
  { id: 165, nombre: 'Suecia' },
  { id: 166, nombre: 'Suiza' },
  { id: 167, nombre: 'Surinam' },
  { id: 168, nombre: 'Tailandia' },
  { id: 169, nombre: 'Tanzania' },
  { id: 170, nombre: 'Tayikistán' },
  { id: 171, nombre: 'Timor Oriental' },
  { id: 172, nombre: 'Togo' },
  { id: 173, nombre: 'Tonga' },
  { id: 174, nombre: 'Trinidad y Tobago' },
  { id: 175, nombre: 'Túnez' },
  { id: 176, nombre: 'Turkmenistán' },
  { id: 177, nombre: 'Turquía' },
  { id: 178, nombre: 'Tuvalu' },
  { id: 179, nombre: 'Ucrania' },
  { id: 180, nombre: 'Uganda' },
  { id: 181, nombre: 'Uruguay' },
  { id: 182, nombre: 'Uzbekistán' },
  { id: 183, nombre: 'Vanuatu' },
  { id: 184, nombre: 'Vaticano' },
  { id: 185, nombre: 'Venezuela' },
  { id: 186, nombre: 'Vietnam' },
  { id: 187, nombre: 'Yemen' },
  { id: 188, nombre: 'Yibuti' },
  { id: 189, nombre: 'Zambia' },
  { id: 190, nombre: 'Zimbabue' }
];



estados_nacimiento: ItemGenerico[] = [
  { id: 1, nombre: 'AGUASCALIENTES' },
  { id: 2, nombre: 'BAJA CALIFORNIA' },
  { id: 3, nombre: 'BAJA CALIFORNIA SUR' },
  { id: 4, nombre: 'CAMPECHE' },
  { id: 5, nombre: 'CHIAPAS' },
  { id: 6, nombre: 'CHIHUAHUA' },
  { id: 7, nombre: 'CIUDAD DE MÉXICO' },
  { id: 8, nombre: 'COAHUILA DE ZARAGOZA' },
  { id: 9, nombre: 'COLIMA' },
  { id: 10, nombre: 'DURANGO' },
  { id: 11, nombre: 'GUANAJUATO' },
  { id: 12, nombre: 'GUERRERO' },
  { id: 13, nombre: 'HIDALGO' },
  { id: 14, nombre: 'JALISCO' },
  { id: 15, nombre: 'MÉXICO' },
  { id: 16, nombre: 'MICHOACÁN DE OCAMPO' },
  { id: 17, nombre: 'MORELOS' },
  { id: 18, nombre: 'NAYARIT' },
  { id: 19, nombre: 'NUEVO LEÓN' },
  { id: 20, nombre: 'OAXACA' },
  { id: 21, nombre: 'PUEBLA' },
  { id: 22, nombre: 'QUERÉTARO' },
  { id: 23, nombre: 'QUINTANA ROO' },
  { id: 24, nombre: 'SAN LUIS POTOSÍ' },
  { id: 25, nombre: 'SINALOA' },
  { id: 26, nombre: 'SONORA' },
  { id: 27, nombre: 'TABASCO' },
  { id: 28, nombre: 'TAMAULIPAS' },
  { id: 29, nombre: 'TLAXCALA' },
  { id: 30, nombre: 'VERACRUZ DE IGNACIO DE LA LLAVE' },
  { id: 31, nombre: 'YUCATÁN' },
  { id: 32, nombre: 'ZACATECAS' },
  { id: 33, nombre: 'NACIDO EN EL EXTRANJERO' }
];






}

interface ItemGenerico {
  id: number;
  nombre: string;
}

interface Pais {
  id: number;
  nombre: string;
}

interface Estado {
  id: number;
  nombre: string;
}